import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Resource, Checkbox, Editor } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const Form = ({ match }) => (
  <View>
    <ResourceForm resource="Location" id={match.params.id}>
      {({ submitting, renderActions }) => (
        <>
          <Card>
            <CardBody className={submitting ? 'loading' : ''}>
              <Row>
                <Col lg={4}>
                  <Input name="name" />
                </Col>
                <Col lg={4}>
                  <Resource name="type" display="name" />
                </Col>
                <Col lg={4}>
                  <Input name="description" />
                </Col>
                <Col lg={12}>
                  <Checkbox name="public" />
                </Col>
                <Col lg={12}>
                  <Editor name="coordinates" height="300" />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="mt-4 mb-4">{renderActions()}</div>
        </>
      )}
    </ResourceForm>
  </View>
);

Form.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default Form;
